/** Жалобы на сообщение, пользователя или сервер (POST /reports). */
import { authed } from './auth'

export type ReportTargetType = 'message' | 'user' | 'guild'
export type ReportCategory = 'spam' | 'fraud' | 'harassment' | 'nsfw' | 'violence' | 'csam' | 'extremism' | 'copyright' | 'other'

export interface ReportTarget {
  type: ReportTargetType
  id: string
  /** Подпись в заголовке окна: «сообщение Пети», «@petya», «сервер «Клан»». */
  label: string
}

export interface ReportResult {
  id: string
  status: 'open' | 'resolved' | 'rejected'
  /** Открытая жалоба от вас на этот объект уже была. */
  existing?: boolean
}

export const REPORT_CATEGORIES: { value: ReportCategory; label: string; hint?: string }[] = [
  { value: 'spam', label: 'Спам или реклама' },
  { value: 'fraud', label: 'Мошенничество', hint: 'фишинг, выманивание денег и данных' },
  { value: 'harassment', label: 'Оскорбления и травля' },
  { value: 'nsfw', label: 'Контент 18+ вне NSFW-каналов' },
  { value: 'violence', label: 'Насилие или угрозы', hint: 'рассматривается в течение 24 часов' },
  { value: 'csam', label: 'Сексуализация несовершеннолетних', hint: 'рассматривается в течение 24 часов' },
  { value: 'extremism', label: 'Экстремизм или терроризм', hint: 'рассматривается в течение 24 часов' },
  { value: 'copyright', label: 'Нарушение авторских прав' },
  { value: 'other', label: 'Другое' },
]

export const reportApi = {
  create: (target: ReportTarget, category: ReportCategory, text: string) =>
    authed<ReportResult>('/reports', { method: 'POST', body: JSON.stringify({ target_type: target.type, target_id: target.id, category, text }) }),
}
